export const getUpdateAccountSettingsPwasPayload = (formValues) => {
    const { appNameSetting, appName } = formValues;
    return {
        customName: appNameSetting === 'custom' ? appName : undefined,
    };
};
